import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import letsTalkI from "../images/lets-talk01.png"
import letsTalkII from "../images/lets-talk02.png"
import letsTalkIII from "../images/lets-talk03.png"
import letsTalkIIII from "../images/lets-talk04.png"

const Footer = () => {
  const { wp } = useStaticQuery(
    graphql`
      query {
        wp {
          globalOptions {
            globalSiteOptions {
              googleMapLink
              email
              phoneNumber
              socialHandles {
                link
                title
              }
            }
          }
        }
      }
    `
  )

  const letsTakeGifFrames = [letsTalkI, letsTalkII, letsTalkIII, letsTalkIIII]
  const [letsTalkGifFrame, setLetsTalkGifFrame] = useState(0)
  const [showCredits, setShowCredits] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      if (letsTalkGifFrame == 3) {
        setLetsTalkGifFrame(0)
      } else {
        setLetsTalkGifFrame(letsTalkGifFrame + 1)
      }
    }, 250)
    return () => clearInterval(interval)
  })

  const socialHandles = wp.globalOptions.globalSiteOptions?.socialHandles
  return (
    <footer className="bg-black text-white pt-16 lrg:pt-32 pb-10">
      <div className="container">
        <div className="flex mb-10">
          <div className="tab:w-1/2 tab:px-6">
            <p className="flex flex-col-reverse md:block">
              Put yourself in the picture. Let’s talk.{" "}
              <span className="inline-block w-16 align-middle mb-8 md:mb-0 md:ml-8">
                <img className={`${ (letsTalkGifFrame == 0) ? 'block' : 'hidden' }`} src={letsTakeGifFrames[0]} />
                <img className={`${ (letsTalkGifFrame == 1) ? 'block' : 'hidden' }`} src={letsTakeGifFrames[1]} />
                <img className={`${ (letsTalkGifFrame == 2) ? 'block' : 'hidden' }`} src={letsTakeGifFrames[2]} />
                <img className={`${ (letsTalkGifFrame == 3) ? 'block' : 'hidden' }`} src={letsTakeGifFrames[3]} />
              </span>
            </p>
          </div>
        </div>
        <div className="lrg:flex">
          <div className="tab:w-1/2 tab:px-6">
            <p className="text-base lrg:text-lg mb-10">
              Standby Productions Ltd Studio Cc, The Classrooms, 13 Stanley Square
              Sale, M33 7XZ
              <br />
              <a
                href={wp.globalOptions.globalSiteOptions?.googleMapLink}
                target="_blank"
                rel="noreferrer"
                className="underline"
              >
                Google Map
              </a>
            </p>
            <p className="text-base lrg:text-lg">
              <a
                href={`tel: ${wp.globalOptions.globalSiteOptions?.phoneNumber}`}
              >
                {wp.globalOptions.globalSiteOptions?.phoneNumber}
              </a>
              <br />
              <a href={`mailto: ${wp.globalOptions.globalSiteOptions?.email}`}>
                Email
              </a>
            </p>
          </div>
          <div className="tab:w-1/2 tab:px-6 pt-10 lrg:pt-0">
            <p className="text-base lrg:text-lg lrg:text-right">
              {socialHandles
                ? socialHandles.map((handle, index) => {
                    return (
                      <React.Fragment key={index}>
                        <a
                          href={handle.link}
                          rel="noreferrer"
                          target="_blank"
                          className="underline block"
                        >
                          {handle.title}
                        </a>
                      </React.Fragment>
                    )
                  })
                : ""}
            </p>
          </div>
        </div>
        <div className="tab:flex justify-between pt-20 pb-10">
          <div className="tab:w-1/2 tab:px-6">
            <p>&copy;2020 Standby Productions.</p>
          </div>
          <div className="tab:w-1/2 tab:px-6 tab:text-right">
            <p className="relative">
              <span
                className={`absolute left-0 tab:right-0 tab:left-auto top-0 bg-black w-full transition-opacity opacity-0${
                  showCredits ? " opacity-100 z-10" : " z-0"
                }`}
              >
                Design:{" "}
                <a
                  href="https://bramcreates.co.uk/"
                  rel="noreferrer"
                  target="_blank"
                  className="underline"
                >
                  BramCreates
                </a>{" "}
                Code:{" "}
                <a
                  href="https://persona.studio/"
                  rel="noreferrer"
                  target="_blank"
                  className="underline"
                >
                  Persona
                </a>
              </span>
              <button
                className={`absolute left-0 tab:right-0 tab:left-auto top-0 z-0 underline`}
                onClick={() => setShowCredits(!showCredits)}
              >
                Website Credits
              </button>
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
